import { useQuery } from '@tanstack/vue-query'

export function useEventCustomerMembershipQuery(id, isAppointment = false) {
  const api = useApi()

  return useQuery({
    queryKey: ['event-customer-membership', id],
    queryFn: async () => {
      const result = await api.getMemberships({
        queryParameters: {
          ...(!isAppointment && { permits_registration_for_event: id }),
          ...(isAppointment && { offering_type: id }),
          any_state: 'for_sale',
        },
        expand: ['plans'],
      })

      return result.results
    },
  })
}
